import * as React from 'react';
import styles from './styles.module.css';
import { Asset, CloseIcon, Pill } from '@clearcover/atlas';
import { AGENT_REWARDS } from '../../../Shared/constants/rewards';

type RewardsTooltipProps = {
  rewardsPortalIndex: number;
  showTooltip: boolean;
  setShowTooltip: (arg0: boolean) => void;
};

const MAIN_NAV_PADDING = 40;
const NAV_ITEM_HEIGHT = 44;

export const RewardsTooltip: React.FC<RewardsTooltipProps> = ({
  rewardsPortalIndex,
  showTooltip,
  setShowTooltip,
}) => {
  if (!showTooltip) {
    return <></>;
  }

  return (
    <div
      className={styles.tooltip}
      style={{
        top: MAIN_NAV_PADDING + rewardsPortalIndex * NAV_ITEM_HEIGHT + 'px',
      }}
    >
      <div className={styles.tooltipHeader}>
        <Pill variant="success" className={styles.tooltipNew}>
          New
        </Pill>
        <div className={styles.tooltipHeaderText}>Clearcover Rewards</div>
        <button
          className={styles.tooltipCloseIcon}
          data-testid="rewards-tooltip-close"
          onClick={() => {
            localStorage.setItem('showRewardsTooltip', 'false');
            setShowTooltip(false);
          }}
        >
          <Asset
            icon={CloseIcon}
            description={'close tooltip'}
            height={12}
            width={12}
          />
        </button>
      </div>
      <div className={styles.tooltipText}>
        Earn up to {AGENT_REWARDS.points} points (${AGENT_REWARDS.value} value)
        for every new policy you sell!
      </div>
      <div className={styles.tooltipArrow} />
    </div>
  );
};
